






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {WebserviceIntegracao} from '@/model/resource/WebserviceIntegracao'
import {InputWebserviceIntegracaoSchema} from '@/schema/resource/WebserviceIntegracao/InputWebserviceIntegracaoSchema'

@Component
export default class PersistWebserviceIntegracaoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputWebserviceIntegracaoSchema()
  webserviceIntegracao = new WebserviceIntegracao()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.webserviceIntegracao.getWebserviceIntegracao(id)
    }

    $.await.done('getWebserviceIntegracao')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.webserviceIntegracao.persistWebserviceIntegracao()
    await Helper.successAndPush(
      'system.success.persist',
      '/webservice-integracao/list'
    )
  }
}
